import firebaseSrv from '@/services/firebaseSrv.js'
export const namespaced = true

function compareValues(key, order = 'asc') {
  return function(a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      return 0
    }

    const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key]
    const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key]

    let comparison = 0
    if (varA > varB) {
      comparison = 1
    } else if (varA < varB) {
      comparison = -1
    }
    return order == 'desc' ? comparison * -1 : comparison
  }
}

export const state = {
  entries: {}
}
export const mutations = {
  ALL_ENTRIES(state, payload) {
    state.entries = payload
  }
}
export const getters = {
  orderedEntries: state => {
    const entries = Object.values(state.entries)
    let sorted = entries.sort(compareValues('total', 'desc'))
    return sorted
  }
}
export const actions = {
  getAllEntries({ commit }) {
    return firebaseSrv
      .readScoredEntries()
      .then(entries => commit('ALL_ENTRIES', entries))
  }
}
